export default function initMobileNavigation() {
    // foreach polyfill ie11
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }

    /**
     * Element.closest() polyfill
     * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
     */
    if (!Element.prototype.closest) {
        if (!Element.prototype.matches) {
            Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        }

        Element.prototype.closest = function (s) {
            const el = this;
            let ancestor = this;
            if (!document.documentElement.contains(el)) return null;
            do {
                if (ancestor.matches(s)) return ancestor;
                ancestor = ancestor.parentElement;
            } while (ancestor !== null);
            return null;
        };
    }

    (function () {
        const navigationElement = document.querySelector('#mobile-navigation');
        const navigationFillElement = document.querySelector('#mobile-navigation-fill');

        if (navigationElement == null || navigationFillElement == null) {
            console.warn("Mobile navigation not loaded, couldn't find key elements");
            return;
        }

        const navigationSlideCloseElement = navigationElement.querySelector(
            '.navigation-item-options .navigation-close-slide',
        );
        const navigationCloseElement = navigationElement.querySelector(
            '.navigation-item-options .navigation-open-slide',
        );

        // Build navigation element with back buttons
        navigationElement.querySelectorAll('nav>ul ul').forEach(function (element) {
            // Only insert if not already present
            if (!element.querySelector('.navigation-close-slide')) {
                element.insertBefore(navigationSlideCloseElement.cloneNode(true), element.children[0]);
            }
        });

        // Build navigation element with next slide buttons
        navigationElement.querySelectorAll('nav>ul li.has-children').forEach(function (element) {
            // Only append if not already present
            if (!element.querySelector('.navigation-open-slide')) {
                element.appendChild(navigationCloseElement.cloneNode(true));
            }

            // Generate submenu title
            const children = element.children;

            if (children.item(1) && children.item(1).tagName.toLowerCase() == 'ul') {
                // Only insert if not already present
                if (!children.item(1).querySelector('.slide-title')) {
                    const submenuTitle = document.createElement('div');
                    submenuTitle.classList.add('slide-title');
                    submenuTitle.innerText = children.item(0).innerText;

                    children.item(1).insertBefore(submenuTitle, children.item(1).children.item(0));
                }
            }
        });

        // add navigation back and next handlers
        navigationElement.addEventListener('click', function (event) {
            if (event.target.classList.contains('navigation-open-slide')) {
                openSlide(event.target);
            }
            // Allow labels with children to just open the sub-menu
            else if (event.target.closest('#mobile-navigation nav .has-children > span')) {
                openSlide(event.target);
            } else if (event.target.classList.contains('navigation-close-slide')) {
                closeSlide(event.target);
            }
        });

        navigationElement.addEventListener('transitionend', animationEndHandler);
        navigationElement.addEventListener('transitioncancel', animationEndHandler);

        // Handle closing events
        let touchStart, touchEnd;
        navigationFillElement.addEventListener('click', close);
        // Swipe Close
        navigationElement.addEventListener('touchstart', (e) => (touchStart = e.targetTouches[0].clientX), {
            passive: true,
        });
        navigationElement.addEventListener('touchmove', (e) => (touchEnd = e.targetTouches[0].clientX), {
            passive: true,
        });

        navigationElement.addEventListener(
            'touchend',
            (e) => {
                if (touchStart - touchEnd > 45) {
                    navigationElement.classList.add('--closing');
                    navigationElement.classList.remove('--open');
                }
            },
            { passive: true },
        );

        // Handle open events
        document.querySelectorAll("a[href='#mobile-navigation']").forEach(function (element) {
            element.addEventListener('click', function (event) {
                event.preventDefault();
                open();
            });
        });

        // provide programatic options to control Mobile Menu
        window.MobileMenu = {
            open: open,
            close: close,
        };

        function isOpening() {
            return navigationElement.classList.contains('--opening');
        }

        function isClosing() {
            return navigationElement.classList.contains('--closing');
        }

        function isOpen() {
            return navigationElement.classList.contains('--open') || isOpening() || isClosing();
        }

        function close() {
            if (isOpen() && !isOpening() && !isClosing()) {
                navigationElement.classList.add('--closing');
                navigationElement.classList.remove('--open');
            }
        }

        function open() {
            if (!isOpen()) {
                navigationElement.classList.add('--open', '--opening');
            }
        }

        function openSlide(nextButtonElement) {
            nextButtonElement.closest('li.has-children').querySelector('ul').classList.add('--show');
        }

        function closeSlide(backButtonElement) {
            backButtonElement.closest('ul').classList.remove('--show');
        }

        function animationEndHandler() {
            if (navigationElement.classList.contains('--closing')) {
                navigationElement.classList.remove('--closing');
            } else if (navigationElement.classList.contains('--opening')) {
                navigationElement.classList.remove('--opening');
            }
        }
    })();
}
